import { Box, Stack, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import useDeviceDetect from 'hooks/useDeviceDetect';
import { FeedbackList } from 'constants/feedbackList';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import css from './FeedbackSection.module.css';
import { useTranslation } from 'hooks/useTranslation';

const FeedbackSection = () => {
    const { t, detect } = useTranslation();

    const { isExtraLargeDesktop } = useDeviceDetect();
    const isMobile = !isExtraLargeDesktop;

    return (
        <Stack
            direction="column"
            alignItems={'center'}
            className={css.feedback_section}
            paddingTop={isMobile ? '40px' : '100px'}
            paddingBottom={isMobile ? '0' : '60px'}
        >
            <Box className={css.container} sx={{ maxWidth: isMobile ? '350px' : '1120px' }}>
                <Typography
                    sx={{
                        fontSize: '28px',
                        fontWeight: '700',
                        lineHeight: '1.25',
                        color: '#000',
                        marginBottom: '4px',
                    }}
                >
                    {t('feedback_section_p1_1')}
                </Typography>
                <Typography
                    sx={{
                        fontSize: '38px',
                        fontWeight: '700',
                        lineHeight: '1.25',
                        background: 'linear-gradient(165deg, #0A2693 0%, #01CFFE 25%, #F2D3CD 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        width: 'fit-content',
                    }}
                >
                    {t('feedback_section_p1_2')}
                </Typography>
                <Swiper
                    key={detect.isArabicLanguage ? 'rtl' : 'ltr'}
                    dir={detect.isArabicLanguage ? 'rtl' : 'ltr'}
                    loop={true}
                    slidesPerView={isMobile ? 1 : 3}
                    spaceBetween={32}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    pagination={isMobile ? false : { clickable: true }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    className={css.mySwiper}
                >
                    {FeedbackList.map((slide) => {
                        return (
                            <SwiperSlide key={slide.username}>
                                <Box className={css.feedback_card}>
                                    <Stack direction={'column'} spacing="20px">
                                        <Stack direction={'row'} gap="12px">
                                            <img src={slide.avatar} width={'64'} height={'64'} alt={slide.username} />
                                            <Stack direction={'column'} spacing="4px">
                                                <Typography
                                                    dir="ltr"
                                                    sx={{
                                                        fontSize: '20px',
                                                        fontWeight: '500',
                                                        lineHeight: '1.25',
                                                        color: '#0C0F21',
                                                    }}
                                                >
                                                    {slide.username}
                                                </Typography>
                                                <img src={'/images/stars.svg'} width={'96'} height={'16'} alt="" />
                                            </Stack>
                                        </Stack>
                                        <Typography
                                            sx={{
                                                fontSize: '12px',
                                                fontWeight: '300',
                                                lineHeight: '1.25',
                                                color: '#72789A',
                                            }}
                                        >
                                            {t(`feedback_${slide.username}`)}
                                        </Typography>
                                    </Stack>
                                </Box>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Box>
        </Stack>
    );
};

export default FeedbackSection;
